// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"2b55be31e779b67cc54a","691":"4fa737f833ac2965dca1"}[chunkId] + ".js";
};